import React, { Fragment } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import styles from './styles.module.scss'

type RichTextSectionProps = {
  content: {
    content: Document[]
  }
  alignText: 'left' | 'center' | 'right'
}

function RichTextSection({
  content,
  alignText = 'left'
}: RichTextSectionProps) {
  return (
    <div className={styles.content}>
      <div className={`${styles.content__text} ${styles[alignText]}`}>
        {content.content.map((e, i) => {
          return (
            <Fragment key={i.toString()}>
              {documentToReactComponents(e)}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default RichTextSection
